// Paired with the guard script in lib/assets.php: the document is marked
// pending only when JS is running, and the stylesheet hides the content while
// that mark is present. Revealing here means the visitor never sees the
// pre-measurement position, and never a permanent blank if anything fails.
function reveal() {
	document.documentElement.classList.remove('sidebar-pull-up-pending');
}

export function initSidebarPullUp() {
	const nav = document.querySelector( '.sidebar-menu-wrap' );
	const content = document.querySelector( '.sidebar-page-content' );
	if ( !nav || !content ) {
		reveal();
		return;
	}

	const mobile = window.matchMedia( '(max-width: 782px)' );

	function sync() {
		if ( mobile.matches ) {
			content.style.marginTop = '';
			content.style.removeProperty( '--sidebar-menu-height' );
			return;
		}

		const height = nav.offsetHeight;

		content.style.marginTop = `-${ height }px`;

		// Pulling the content up over the menu means the region is only as
		// tall as the content, so on a short page -- an empty cart, a
		// one-line notice -- the menu carried on past it and over the footer.
		// The stylesheet turns this into a min-height; it is published as a
		// property rather than set directly so the rule stays visible there.
		content.style.setProperty( '--sidebar-menu-height', `${ height }px` );
	}

	const ro = new ResizeObserver( sync );
	ro.observe( nav );

	mobile.addEventListener( 'change', sync );
	window.addEventListener( 'load', sync );
	sync();
	reveal();
}
